import React from 'react';
import { formatStartDate } from '../../utils/dateUtils';
import { parseISO } from 'date-fns';
import {
    DueDateContainer,
    DueDateInfo,
    DueDateText,
} from '../../styles/CardStartDate.styles';

const CardStartDate = ({ cardData }) => {
    if (!cardData || !cardData.startDate) {
        return null;
    }

    const parsedDate = typeof cardData.startDate === 'string' ? parseISO(cardData.startDate) : cardData.startDate;
    const formattedDateString = formatStartDate(parsedDate);

    return (
        <DueDateContainer>
            <DueDateInfo>
                <DueDateText>
                    {formattedDateString}
                </DueDateText>
            </DueDateInfo>
        </DueDateContainer>
    );
};

export default CardStartDate;
